import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardTypography} from "patient-ping-remedy/packages/typography";
import Button, {StyleType} from "patient-ping-remedy/packages/button";
import Icon, {ICONS} from "patient-ping-remedy/packages/icon";
import Spinner from "patient-ping-remedy/packages/spinner";
import {css} from "@emotion/css";
import Modal from "patient-ping-remedy/packages/modal";

interface ExportModalProps {
    isOpen: boolean;
    onClose: () => void;
    onExport: () => void;
    isExporting: boolean;
}

export default function ExportModal({isOpen, onClose, onExport, isExporting}: ExportModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      headerText="Export Report"
      className={css({ width: '70rem' })}
      buttons={[
        <Button key="cancel" styleType={StyleType.TERTIARY} onClick={onClose}>
          Cancel
        </Button>,
        <Button key="export" onClick={onExport} disabled={isExporting}>
          <span className={css({ display: 'flex', alignItems: 'center', gap: sizes.xSmall })}>
            {isExporting
              ? <Spinner color={colors.gray4} />
              : <Icon iconClass={ICONS.download} />}
            Export
          </span>
        </Button>
      ]}
    >
      <StandardTypography>
        This report contains Client PHI. Are you sure you want to export this report?
        If you continue, PHI will be exported from the system.
      </StandardTypography>
    </Modal>
  );
}
